module.exports = __webpack_public_path__ + "static/media/s17.3248baee.png";